"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const currentDate = new Date().toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
  return <footer id="footer" ref={ref} className={`bg-background border-t border-border py-8 transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          {}
          <div className="flex items-center gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535234/img/image_lkz4m4x6.png" alt="Bright MLS Logo" className="h-24 w-auto" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535234/img/image_a663whzi.webp" alt="Equal Housing Opportunity" className="h-12 w-auto opacity-90" />
          </div>

          {}
          <nav className="flex flex-wrap items-center justify-center md:justify-end gap-6">
            <Link to="/BuyPage" className="text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative group">
              Buy
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] group-hover:w-full"></span>
            </Link>
            <Link to="/SellPage" className="text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative group">
              Sell
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] group-hover:w-full"></span>
            </Link>
            <Link to="/OurAgentsPage" className="text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative group">
              Our Agents
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] group-hover:w-full"></span>
            </Link>
            <Link to="#" className="text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative group">
              Client Login
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] group-hover:w-full"></span>
            </Link>
            <Link to="#" className="text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative group">
              Agent Login
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] group-hover:w-full"></span>
            </Link>
            <Link to="/ContactPage" className="text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative group">
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] group-hover:w-full"></span>
            </Link>
          </nav>
        </div>

        {}
        <div className="border-t border-muted pt-8 mt-8">
          <div className="max-w-5xl mx-auto space-y-4">
            <h3 className="text-lg font-display text-accent mb-4">
              Bright MLS Feed Required Disclosures and Notifications
            </h3>
            
            <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
              <p className="text-foreground font-semibold">
                © BRIGHT, All Rights Reserved
              </p>
              
              <p>
                <strong className="text-foreground">Information Deemed Reliable But Not Guaranteed.</strong> The data relating to real estate for sale on this website appears in part through the BRIGHT Internet Data Exchange program, a voluntary cooperative exchange of property listing data between licensed real estate brokerage firms in which VAZE REALTY participates, and is provided by BRIGHT through a licensing agreement.
              </p>
              
              <p>
                The information provided by this website is for the personal, non-commercial use of consumers and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing.
              </p>
              
              <p className="text-foreground">
                Data last updated: {currentDate}
              </p>
              
              <p>
                Some properties which appear for sale on this website may no longer be available because they are under contract, have Closed or are no longer being offered for sale.
              </p>
              
              <p>
                Some real estate firms do not participate in IDX and their listings do not appear on this website. Some properties listed with participating firms do not appear on this website at the request of the seller.
              </p>
              
              <p>
                This home sale information is not to be construed as an appraisal and may not be used as such for any purpose.
              </p>
              
              <p>
                BRIGHT MLS is the (or a) provider of this home sale information and has compiled content from various sources. Some properties represented may not have actually sold due to reporting errors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}